import { render, staticRenderFns } from "./Checkin.vue?vue&type=template&id=2b0228a2&"
import script from "./Checkin.vue?vue&type=script&lang=js&"
export * from "./Checkin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports